import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Category} from '../../_models';
import {FormControl, FormGroup} from '@angular/forms';
import {first} from 'rxjs/operators';
import {CategoryService} from '../../_services';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss']
})
export class CreateCategoryComponent {

    @Input() intercalaireId: string;
    @Input() category: Category;

    @Output() refreshEvent = new EventEmitter<string>();

    categoryForm = new FormGroup({
        name: new FormControl(''),
    });


    errors = [];

  constructor(private categoryService: CategoryService) { }

    submit() {

        const category = new Category({});
        category.name = this.categoryForm.value.name;

        this.errors = [];
        let isOK = true;

        if (category.name === '') {
          this.errors[`name`] = true;
          isOK = false;
        }

        if (!isOK) {
          return;
        }


        if (this.category) {
            this.categoryService.registerByParentId(this.category.id, category).pipe(first()).subscribe(result => {
                this.categoryForm.reset();
                this.refreshEvent.next();
            });
        } else {
            this.categoryService.registerByIntercalaireId(this.intercalaireId, category).pipe(first()).subscribe(result => {
                this.categoryForm.reset();
                this.refreshEvent.next();
            });
        }
    }

}
